module.exports = __webpack_public_path__ + "static/img/MAG.4c900fb8.jpg";